import { Container } from "aurelia-framework";
import store from "../store";
import { IState, LocationState } from "../state";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { Location } from "../../models/location";
import * as Enumerable from "linq-es2015";
import { AddDeviceRequestViewModel } from "../../models/add-device-request-view-model";
import { Zone } from "../../models/zone";
import { Structure } from "../../models/structure";

const api: Api = Container.instance.get(Api);

export async function addDevice(state: IState, locationId: string, zoneId: string, addDeviceRequest: AddDeviceRequestViewModel) {
	const newState = Object.assign({}, state);
	applicationLogger.debug("Adding new device");

	const newDevice = await api.addDevice(addDeviceRequest);

	let location = newState.locationState.locations.find((l: Location) => l.id === locationId);
	if (location) {
		let zone = location.zones.find((z: Zone) => z.id === zoneId);
		if (zone) {
			let structure = zone.structures.find((s: Structure) => s.id === addDeviceRequest.structureId);
			if (structure) {
				structure.devices.push(newDevice);
			}
		}
	}

	// add to selectedLocation state.
	location = newState.locationState.selectedLocations.find((l: Location) => l.id === locationId);
	if (location) {
		let zone = location.zones.find((z: Zone) => z.id === zoneId);
		if (zone) {
			let structure = zone.structures.find((s: Structure) => s.id === addDeviceRequest.structureId);
			if (structure) {
				structure.devices.push(newDevice);
			}
		}
	}

	// Find location
	// if location, find zone
	// if zone, find structure
	// add device to devices collection
	return newState;
}
